import Chip from '@mui/material/Chip';
import { getOrderStatus } from '../colorsServices';

const OrderStatusChip = ({ status, size = 'small', variant = 'filled', ...props }) => {
    const statusConfig = getOrderStatus(status);
    
    if (!statusConfig) {
        return <Chip size={size} label={status} color="default" {...props} />;
    }
    
    return (
        <Chip
            size={size}
            label={statusConfig.label}
            color={statusConfig.color}
            variant={variant}
            {...props}
        />
    );
};

export default OrderStatusChip;